/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  var lang = 'en';
  if (document.getElementsByTagName("body")[0].className.match(/lang-fr/)) {
    lang = 'fr';
  }
  else if (document.getElementsByTagName("body")[0].className.match(/lang-es/)) {
    lang = 'es';
  }

  // Hide spanish option from language switcher
  $('.woocommerce-page .site-branding .lng ul li').each(function () {
    if ($(this).text().trim().includes('Español')) {
      $(this).hide();
    }
  });
  
  // Prevent scroll top on add to cart
  $.fn.matchHeight._maintainScroll = true;

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All WooCommerce pages
    'woocommerce_page': {
      init: function() {
        // JavaScript to be fired on all WooCommerce pages
        // Review comment pre-validation
        // UTIL.fire('woocommerce_page', 'updateCart');

        // MatchHeight functions
        UTIL.fire('woocommerce_page', '_matchHeight');
      },

      registerWindowOnResize: function(oParams) {
        $(window).bind('resize', function () {
          waitForFinalEvent(function(){
            UTIL.fire(oParams.sController, oParams.sFunction, oParams.sParam);
          }, iWindowResizeTimeout, oParams.sController + "." + oParams.sFunction);
        });
      },

      // updateCart: function() {

      // },

      _matchHeight: function() {
        // if($('.woocommerce-page.single-product').length) {
          $('.woocommerce-page.single-product #mainContent .product .thumbnails a').matchHeight();
          $('.woo-products-listing .products a:not(.button):not(.added_to_cart)').matchHeight();
          $('.woo-products-listing .products .content').matchHeight();
        // }

        if($('.woocommerce-page.archive').length) {
          $(document).ajaxSuccess(function() {
            $('#mainContent .products').imagesLoaded( function() {
              $('#mainContent .products').each(function(){
                $(this).find('a:not(.button):not(.added_to_cart)').matchHeight();
                $(this).find('.content').matchHeight();
              });
            });
          });
        }
      }
    },

    // Listing
    'archive': {
      init: function() {
        // JavaScript to be fired on WooCommerce listing page

        // Show/hide according to browser dimensions
        UTIL.fire('archive', 'responsiveFilter');

        // Open/Close section headers
        UTIL.fire('archive', 'bindHeadersAccordion');

        // Hide empty filter groups
        UTIL.fire('archive', 'emptyFilters');

        // Add functionnalities to mobile version
        UTIL.fire('archive', 'bindMobileMainFilter');

        // Archive facetwp PageLoader
        UTIL.fire('archive', 'pagerLoader');

        // Archive product categories filter / navigation
        UTIL.fire('archive', 'categoryFilterNavigation');
      },

      categoryFilterNavigation: function() {
        $('#sidebar .filter .nav .menu-item.active').parents('.menu-item').addClass('active');

        $('#sidebar .filter .nav .menu-item:not(.active) .sub-menu').each(function(){
          $(this).slideToggle('slow');
        });

        $('#sidebar .filter .nav .trig').click(function(){
          $(this).parents('.menu-item-has-children').first().find('.sub-menu').first().slideToggle('slow');
          
          var target = $(this).parents('.menu-item-has-children').first();

          if (target.hasClass('on')) {
            target.removeClass('on');
          } else {
            target.addClass('on');
          }
        });
      },

      pagerLoader: function() {
        var loaded = false;

        var target;
        var bIsPromo = false;
        var bIsBlog = false;

        target = '#mainContent .facetwp-template .products';

        $(document).on('facetwp-refresh', function() {
          if ( loaded ) {

            $(target).addClass('loading');

            $('<div class="listing-loading"></div>').insertAfter(target);
          }
        });

        $(document).on('facetwp-loaded', function() {

          // Hide container without any options available
          $.each(FWP.settings.num_choices, function(key, val) {
            var $parent = $('.facetwp-facet-' + key).parent();
            if( $parent.attr('data-keepclass') !== 'hidden' ){
              (0 === val) ? $parent.addClass('hidden') : $parent.removeClass('hidden');
            }
          });

          if ( loaded ) {

            $(target).removeClass('loading');

            if ($('#mainContent .facetwp-template .listing-loading').length ) {

              $('#mainContent .facetwp-template .listing-loading').fadeOut(100);

            }

            if( target ) {
              $('html, body').animate({
                scrollTop: $(target).offset().top
              }, 500);
            }

          }
          else {
            loaded = true;

            if (FWP.extras.sort === 'default' ) {
              need_refresh = false;
              setTimeout(function(){
                FWP.extras.sort = 'newest';
                FWP.refresh();
              }, 500);
            }
          }

        });
      },


      bindHeadersAccordion: function() {

        $("#sidebar .filter section > header > button").each(function(iIndex){

          // Bind a click event on the button
          $(this).bind('click.pgsAccordion', function(){

            var $jqHeader = $(this).parent();
            var $jqContent = $jqHeader.next();

            if( ! $jqHeader.hasClass('on') ) {
              $jqHeader.addClass('on');
              $jqContent.slideDown('400', 'swing');
            }
            else {
              $jqHeader.removeClass('on');
              $jqContent.slideUp('400', 'swing');
            }

            delete $jqContent;
            delete $jqHeader;

          });


        });
      },

      bindMobileMainFilter: function() {
        $("#sidebar .filter > header button:first").bind('click.pgsMainFilter', function(){

          // For each filter groups, remove the header class "on"
          $("#sidebar .filter .wrap .content header button").each(function(){
            if( $(this).parents('header:first').hasClass('on') ) {
              $(this).trigger('click');
            }
          });

        });
      },

      emptyFilters: function(){
        if( ! $("#mainContent .facetwp-template .products .product").length ) {
          $('#sidebar .filter.custom section .facetwp-type-checkboxes').each(function() {
            $(this).parents('section:first').addClass('hidden').removeClass('on');
          });
          return;
        }

        $(document).on('facetwp-loaded', function() {
          $('#sidebar .filter.custom section .facetwp-type-checkboxes').each(function() {
            if ( ! $(this).find('.facetwp-checkbox').length ) {
              $(this).parents('section:first').addClass('hidden').removeClass('on');
            }
            else {
              $(this).parents('section:first').removeClass('hidden on');
            }
          });

          $('#sidebar .filter.custom section:not(.hidden)').first().addClass('first-visible');
        });
      },


      responsiveFilter: function(){
        // If the user clicks outside the filter content while it's opened
        $(document).on('click', function(event) {
          if($('#sidebar .filter > .content').hasClass('opened')) {
            if(!$(event.target).closest('#sidebar .filter .wrap, #sidebar .filter > header, #sidebar .filter .wrap > button').length) {
              $('#sidebar .filter > .content').removeClass('opened');
            }
          }
        });

        $('#sidebar .filter > header button').click(function() {
          if($('body.mobile').length) {
            $('#sidebar .filter > .content').addClass('opened');
          }

          $(this).blur();
        });

        $('#sidebar .filter .wrap > button').click(function() {
          $('#sidebar .filter > .content').removeClass('opened');

          $(this).blur();
        });

        $('#sidebar .filter > .content').swipeleft(function(){
          $('#sidebar .filter > .content').removeClass('opened');
        });
      },

    },

    // Single product
    'single_product': {
      init: function() {
        // JavaScript to be fired on WooCommerce single product page

        // Review comment pre-validation
        UTIL.fire('single_product', 'changeTabsToDrop');
        UTIL.fire('woocommerce_page', 'registerWindowOnResize', {sController:'single_product', sFunction:'changeTabsToDrop', sParam:'resize'});
        // UTIL.fire('single_product', 'reviewValidation');
      },

      changeTabsToDrop: function(action){
        // Turn tabs into a dropdown if there is not enough space
        // console.info('ChangeTabsToDrop', action);
        // return;
        if($('.woocommerce-tabs.wc-tabs-wrapper').length) {
          var $tabGroups = $('.woocommerce-tabs.wc-tabs-wrapper');
          // console.log("NbTabGroups", $tabGroups.length);
          if( ! $tabGroups.find('.dropdown-toggle:first').length ) {
            $tabGroups.prepend('<button type="button" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="label">Section</span> <span class="caret"></span></button>');
          }
          // If calling this when the window is resized, we need to put back as UL before we calculate anything
          if(action && action == 'resize') {
            $tabGroups.removeClass('btn-group');
            $tabGroups.find('.dropdown-menu').removeClass('dropdown-menu');
          }

          $tabGroups.each(function(){
            var $group = $(this);
            var $tabs = $group.find('.tabs');
            var $tabItems = $tabs.find('> li');
            var tabsWidth = 0;
            var $btn = $group.find('> button');
            //

            // Don't do this for vertical tabs or other ones that we need more control over
            if(!$group.hasClass('noAutoSwitch')) {
              // Normal tabs
              if(!$group.hasClass('customSwitch')) {
                var availableWidth = $group.width();
              }
              // Tabs using a different width calculation
              else {
                var availableWidth = $group.parents('.customSwitchWrap').width() - $group.siblings().width();
              }


              // Calculate tabs width
              $tabItems.each(function(){
                tabsWidth += $(this).outerWidth(true);
              });
              // console.log("Available", availableWidth, "Tabs", tabsWidth);
              // If there is not enough space for the UL to be displayed on 1 line, show the dropdown instead
              if(tabsWidth > availableWidth) {
                $group.addClass('btn-group');
                $tabs.addClass('dropdown-menu');

                if(!$group.hasClass('noBtnLabelSwitch')) {
                  // Change button label text to current active tab
                  $btn.find('.label').html($group.find('.active a').html());
                }
              }
              else {
                $group.removeClass('btn-group');
                $tabs.removeClass('dropdown-menu');
              }
            }

            // We need to call some Bootstrap JS so the tab switching still works
            $tabItems.find('a').click(function(e){
              // Check if they're real tabs:
              // If .wc-tab exists
              if($(this).parents('.woocommerce-tabs.wc-tabs-wrapper:first').find('.wc-tab').length) {
                $tabItems.not($(this).parent()).removeClass('active');

                $(this).tab('show');

                if(!$group.hasClass('noBtnLabelSwitch')) {
                  // Change button label text to clicked tab
                  $btn.find('.label').html($(this).html());
                }
              }

              $(this).blur();
            });
          });

          // Make sure the dropdown menu also works
          $('.dropdown-toggle').dropdown();
        }
      },

      reviewValidation: function() {
        // Set error message (lang)
        var error_message = '';
        if (lang == 'fr') {
          error_message = 'Veuillez entrer un commentaire.';
        } else {
          error_message = 'Please enter a comment.';
        }

        // Prevent form submission and print error message if textarea is empty
        $('#reviews form #submit').click(function(){
          if (!$('#reviews form #comment').val()) {
            if (!$('#reviews form .form-submit').siblings('.woo-error').length) {
              $('#reviews form .form-submit').after('<div class="woocommerce-error woo-error">'+error_message+'</div>');
            }
            return false;
          } else {
            if ($('#reviews form .form-submit').siblings('.woo-error').length) {
              $('#reviews form .form-submit').siblings('.woo-error').remove();
            }
          }
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
